import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { Spin } from 'antd';
import queryString from 'query-string';
import AuthShell from './AuthShell';
import { slackUserLogin } from './authApi';
import {
  readReturnPath,
  clearReturnPath,
  withWorkspace,
  isWorkspaceScoped,
} from './returnPath';

// Handles Slack's OIDC redirect: exchanges the code via the backend (which
// sets cookies), then hands off to the app shell.
const TrooprSlackCallback = (props) => {
  const [error, setError] = useState('');

  useEffect(() => {
    const qs = queryString.parse(window.location.search);
    if (!qs.code) {
      setError('Slack sign-in was cancelled or failed.');
      return;
    }
    const redirectUri = `${window.location.origin}/troopr/slack_callback`;
    slackUserLogin({ code: qs.code, redirectUri })
      .then((res) => {
        if (res.data && res.data.success) {
          // Full page load — the path comes back from storage.
          const returnPath = readReturnPath(window.location.search);
          const wId =
            res.data.workspaceId ||
            localStorage.getItem('userCurrentWorkspaceId');
          if (returnPath && (isWorkspaceScoped(returnPath) || wId)) {
            clearReturnPath();
            window.location.href = withWorkspace(returnPath, wId);
          } else {
            window.location.href = '/user-workspaces';
          }
        } else {
          setError((res.data && res.data.message) || 'Slack sign-in failed.');
        }
      })
      .catch(() => setError('Slack sign-in failed. Please try again.'));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <AuthShell>
      {error ? (
        <>
          <h1 className="tpr-auth__title">Sign-in failed</h1>
          <p className="tpr-auth__subtitle">{error}</p>
          <span
            className="tpr-auth__link"
            onClick={() => props.history.replace('/troopr/access')}
          >
            Back to sign in
          </span>
        </>
      ) : (
        <div style={{ textAlign: 'center', padding: '24px 0' }}>
          <Spin />
          <p className="tpr-auth__subtitle" style={{ marginTop: 16 }}>
            Completing Slack sign-in…
          </p>
        </div>
      )}
    </AuthShell>
  );
};

export default withRouter(TrooprSlackCallback);
